<html>
  <body id="element-to-export">
    <div data-html2canvas-ignore="true">
      <h2 class="title">
        Rentabilidad de alternativas para seguros con ahorro flexible
        &nbsp;&nbsp;
        <button
          (click)="onExportClick(s)"
          [class.spinner]="loading"
          [disabled]="loading"
          mat-stroked-button
        >
          Descargar PDF &nbsp;&nbsp;
          <img
            style="width: auto; height: 1rem;"
            src="../../../../../assets/icons/download.svg"
          />
        </button>
      </h2>
    </div>
    <div class="table-columns header">
      <div class="renta-12-meses">
        <b>Rtb. Acum. Últimos 12 Meses</b>
      </div>
      <div class="renta-6-meses">
        <b>Rtb. Acum. Últimos 6 Meses</b>
      </div>
      <div class="renta-mes-actual">
        <b>{{ FechaMesCerrado }}</b>
      </div>
    </div>
    <div
      class="main-conatiner"
      *ngFor="let administrador of data?.Administrador"
    >
      <div
        *ngIf="administrador.NombreAdministrador?.trim().length > 0"
        class="administrador"
      >
        {{ administrador.NombreAdministrador }}
      </div>
      <div
        class="subtable-columns background border-bottom"
        *ngFor="let riesgo of administrador.ListadoRiesgo; let i = index"
      >
        <div class="tipo-riesgo">
          {{ riesgo.TipoRiesgo }}
        </div>
        <div class="agrupacion">
          <div *ngFor="let agrupacion of riesgo.ListadoAgrupacion">
            <div
              [ngClass]="
                agrupacion.FLAG
                  ? 'subtable-columns-riesgo'
                  : 'subtable-columns-riesgo2'
              "
            >
              <div class="tipo-riesgo">
                {{ agrupacion.NombreAgrupacion }}
              </div>
              <div class="alternativas-container">
                <div
                  class="alternativa-table"
                  *ngFor="let alternativas of agrupacion.AlternativaInversion"
                >
                  <div class="fondo">{{ alternativas.NOMBRE_FONDO }}</div>
                  <div class="fondo align-center rent-12-meses">
                    {{ alternativas.RENTABILIDAD_12_MESES }}
                  </div>
                  <div class="fondo align-center rent-6-meses">
                    {{ alternativas.RENTABILIDAD_6_MESES }}
                  </div>
                  <div class="fondo align-center rent-1-meses">
                    {{ alternativas.RENTABILIDAD_1_MESES }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="disclaimer" data-html2canvas-ignore="true">
      <span>
        *Fondo Global Brands Fund cerrado para nuevos aportes.
      </span>
    </div>
    <div class="disclaimer" data-html2canvas-ignore="true">
      <span>
        **Fondos Mutuos Morgan Stanley solo para pólizas emitidas hasta el 31 de
        diciembre de 2015.
      </span>
    </div>
  </body>
</html>
